import React, { useState, useEffect } from 'react';

import EmailVerificationView from '../components/login/emailVerification'
import PhoneVerificationView from '../components/login/phoneVerification'
import AcountLoginView from '../components/login/acountLogin'
import ResetPasswordView from '../components/login/resetPassword'
import LoginPageView from '../components/login/loginPage'
import LoadAccount from '../components/login/loadAccount'
import AcountVerificationView from '../components/login/acountVerification'

import "../assets/css/login.css"

const Login: React.FC = () => {

    const [currentView, setCurrentView] = useState('mainLogin');
    const [viewData, setViewData] = useState(null);

    useEffect(() => {
            localStorage.setItem('userToken', '');
            localStorage.setItem('userName', '');
            localStorage.setItem('userId', '');
            localStorage.setItem('id', '');
            localStorage.setItem('userPhone', '');
            localStorage.setItem('userEmail', '');
            localStorage.setItem('accountName', '');
            localStorage.setItem('headImg', '');
    }, [])

    const renderView = () => {
        console.log(currentView)
        switch (currentView) {
            //登录主页
            case 'mainLogin':
                return <LoginPageView handleViewChange={handleViewChange} data={viewData} />;
            //邮箱验证码
            case 'emailVerification':
                return <EmailVerificationView handleViewChange={handleViewChange} data={viewData} />;
            //手机验证码
            case 'phoneVerification':
                return <PhoneVerificationView handleViewChange={handleViewChange} data={viewData} />;
            //账号登录
            case 'accountLogin':
                return <AcountLoginView handleViewChange={handleViewChange} data={viewData} />;
            //输入找回密码的账号
            // case 'loadAccount':
            //     return <LoadAccount handleViewChange={handleViewChange} data={viewData} />;
            // //重置密码前的身份验证
            // case 'credentialsVerification':
            //     return <AcountVerificationView handleViewChange={handleViewChange} data={viewData} />;
            // //重置密码
            // case 'resetPassword':
            //     return <ResetPasswordView handleViewChange={handleViewChange} data={viewData} />;
            default:
                return <LoginPageView handleViewChange={handleViewChange} data={viewData} />; // 默认视图
        }
    };

    // 处理视图切换的函数，可以根据需要绑定到按钮或其他交互元素上
    const handleViewChange = (newView: string, data?: any) => {
        setCurrentView(newView);
        setViewData(data);
    };

    return (
            <div className='login_content'>
                {renderView()}
            </div>  
    )

};

export default Login;